import { styled } from '@/lib/utils'

export const OverviewPageContainer = styled('div')('flex flex-col gap-4')

export const OverviewPageHeader = styled('div')('flex items-center gap-4')
